export const useNomadTimeout = (delay: number) => {
  const timeout = useTimeout(delay, {
    controls: true,
    immediate: false,
  });
  return timeout;
};
